export const BRAND = {
  name: "Thecoventures",
  tagline: "From Vision To Venture",
  logo: "/logo.png",
  logoFallback:
    "https://customer-assets.emergentagent.com/job_vend-modern/artifacts/bzkasv26_Logo.png",
  logoWidth: 412,
  logoHeight: 151,
  email: "connect@thecoventures.com",
  phone: "+91 97277 65220",
  // E.164 (no +, no spaces) used by wa.me / api.whatsapp.com deep links.
  whatsapp: "919727765220",
  address: "Vadodara, Gujarat, India",
};

export const NAV = [
  { id: "machines", label: "Machines" },
  { id: "how-it-works", label: "How It Works" },
  { id: "why-us", label: "Why Us" },
  { id: "industries", label: "Industries" },
  { id: "proof", label: "Customer Stories" },
  { id: "contact", label: "Contact Us" },
];

// Selling is the core; rental + AMC follow.
export const PRODUCT_OPTIONS = [
  "Buy — Snack & Beverage Vending Machine",
  "Buy — PPE / Safety Vending Machine",
  "Buy — Stationery Vending Machine",
  "Buy — Smart Vending (cashless + telemetry)",
  "Annual Maintenance Contract (AMC)",
  "Rental — Corporate customer only",
  "Not sure yet — advise me",
];

// Partner / industry brand logos shown in the "Trusted across India" marquee.
// Self-hosted in /public/partners/ so mobile carriers / captive proxies that
// occasionally drop cross-origin CDN images cannot break the logo strip.
export const TRUST_LOGOS = [
  {
    name: "Vendiplus",
    url: "/partners/vendiplus.jpg",
    fallback:
      "https://customer-assets.emergentagent.com/job_vend-modern/artifacts/mmqif0n1_Vendiplus%20LOGO.jpeg",
  },
  {
    name: "Unicorn Vending",
    url: "/partners/unicorn.jpg",
    fallback:
      "https://customer-assets.emergentagent.com/job_vend-modern/artifacts/r1vfz4pw_Unicorn.jpg",
  },
  {
    name: "Revend",
    url: "/partners/revend.jpg",
    fallback:
      "https://customer-assets.emergentagent.com/job_vend-modern/artifacts/u2c6dimf_Revend.jpg",
  },
  {
    name: "DoonBox",
    url: "/partners/doonbox.jpg",
    fallback:
      "https://customer-assets.emergentagent.com/job_vend-modern/artifacts/7wf7qqwr_WhatsApp%20Image%202026-06-26%20at%202.22.09%20PM.jpeg",
  },
];

// Brochure PDFs (public URLs).
export const BROCHURES = {
  core: {
    name: "Refuel CORE",
    url:
      "https://customer-assets.emergentagent.com/job_89253960-f0c7-4336-82b9-42ef99a12b7c/artifacts/0a49gtv5_Refuel_CORE_Brochure.pdf",
  },
  lite: {
    name: "Refuel LITE",
    url:
      "https://customer-assets.emergentagent.com/job_89253960-f0c7-4336-82b9-42ef99a12b7c/artifacts/mksfqgnu_Refuel_LITE_Brochure_Premium%20%281%29.pdf",
  },
  max: {
    name: "Refuel MAX",
    url:
      "https://customer-assets.emergentagent.com/job_89253960-f0c7-4336-82b9-42ef99a12b7c/artifacts/0kqfylef_Refuel_MAX_Brochure.pdf",
  },
  safe: {
    name: "Refuel SAFE",
    url:
      "https://customer-assets.emergentagent.com/job_89253960-f0c7-4336-82b9-42ef99a12b7c/artifacts/payaejtz_Refuel_SAFE_Brochure.pdf",
  },
};

/**
 * Build an api.whatsapp.com/send deep link. Works on both desktop and mobile.
 */
export function buildWhatsAppUrl(message = "") {
  const text = encodeURIComponent(message);
  return `https://api.whatsapp.com/send?phone=${BRAND.whatsapp}${text ? `&text=${text}` : ""}`;
}

/**
 * Compose a clean message body for sales.
 */
export function buildInquiryMessage(form) {
  const lines = [
    "Hi Thecoventures team, I’d like to enquire about a vending machine.",
    "",
    `• Name: ${form?.full_name || "(not provided)"}`,
    `• Mobile: ${form?.mobile || "(not provided)"}`,
  ];
  if (form?.email) lines.push(`• Email: ${form.email}`);
  lines.push(`• Requirement: ${form?.product_requirement || "(not selected)"}`);
  if (form?.notes) lines.push(`• Notes: ${form.notes}`);
  return lines.join("\n");
}
